import { useContext } from 'react';

import { HttpClientContext } from '~/HttpClient';

export function useHttpClient() {
  const client = useContext(HttpClientContext);
  return client;
}
